/* eslint-disable import/no-anonymous-default-export */
import React, { useState, useEffect, useRef, useCallback } from "react"
import { makeStyles } from "@mui/styles"
import {
    MenuItem,
    Select,
    Typography,
} from "@mui/material"
import { ReactComponent as PlusIcon } from "../icons/plus.svg"
import { ReactComponent as MinusIcon } from "../icons/minus.svg"
import ArrowDown from "../assets/icons/arrow-down.svg"
import ArrowUp from "../assets/icons/arrow-up.svg"
import ViewDetailIcon from "../assets/icons/document-chart.svg"
import avatarIcon from "../icons/avatar.svg"
import { useTranslation } from "react-i18next"
import * as Util from "../services/global.service"
import moment from "moment"

import "orgchart"
import $ from "jquery"

const useStyles = makeStyles({
})

let goalChartInstance = null
let $chart = null
let cssDiv = null
let values = null
let aValue = null
let bValue = null
let currentZoom = null
let zoomLevel = [0.25, 0.5, 0.75, 1, 1.5, 2, 3]

const zoomInstance = () => {
    console.log("zoom instance")
    $chart = $chart ?? $('#goal-chart')
    $chart.css('transform', "scale(1,1)")
    cssDiv = $chart.css('transform')
    values = cssDiv.split('(')[1]
    values = values.split(')')[0]
    values = values.split(',')
    aValue = values[0]
    bValue = values[1]
    currentZoom = Math.sqrt(aValue * aValue + bValue * bValue)
}

const GoalChart = (props) => {
    const divRef = useRef(null)
    const classes = useStyles()
    const [currentZoomSelected, setCurrentZoomSelected] = useState(1)
    const { i18n } = useTranslation()
    const [isDomChartReady, setIsDomChartReady] = useState(false)
    const [toggleIconStatus, setToggleIconStatus] = useState([])

    const validateActualValueColor = (value, target = null, metric = null, condition = null) => {
        let result = false
        let targetCondition = ""
        if (condition && condition !== "") {
            targetCondition = condition.toLowerCase()
        }
        if (targetCondition !== "") {
            if (targetCondition === "equal") {
                if (parseFloat(target) === parseFloat(value)) {
                    result = true
                }
            } else if (targetCondition === "higher or equal to") {
                if (parseFloat(target) <= parseFloat(value)) {
                    result = true
                }
            } else if (targetCondition === "less or equal to") {
                if (parseFloat(target) >= parseFloat(value)) {
                    result = true
                }
            } else if (targetCondition === "higher") {
                if (parseFloat(target) < parseFloat(value)) {
                    result = true
                }
            } else if (targetCondition === "less") {
                if (parseFloat(target) > parseFloat(value)) {
                    result = true
                }
            }
        } else {
            if (metric?.toLowerCase() === "accomplishment" || metric?.toLowerCase() === "ทำสำเร็จหรือไม่") {
                if (target?.toLowerCase() === value?.toLowerCase()) {
                    result = true
                }
            } else if (metric?.toLowerCase() === "date" || metric?.toLowerCase() === "ทำได้ภายใน end date") {
                let targetValue = moment(String(target), "DD-MM-YYYY")
                let actualValue = moment(String(value), "DD-MM-YYYY")
                let diff = targetValue.diff(actualValue, 'days')
                if (diff >= 0) {
                    result = true
                }
            } else {
                if (target >= value) {
                    result = true
                }
            }
        }
        return result
    }

    const setZoomLevel = (val) => {
        currentZoom = val
        $chart.css('transform', cssDiv + " scale(" + val + "," + val + ")")
        console.log("set zoom level " + currentZoom)
        setCurrentZoomSelected(currentZoom)
    }

    const doZoom = (val) => {
        let zoomValue = 1
        let getCurrentZoomIndex = zoomLevel.findIndex(zoom => zoom === currentZoom)
        if (val === "in") {
            if (zoomLevel[getCurrentZoomIndex + 1]) {
                zoomValue = currentZoom = zoomLevel[getCurrentZoomIndex + 1]
                $chart.css('transform', cssDiv + " scale(" + zoomValue + "," + zoomValue + ")")
                console.log("zoomin " + zoomValue)
                setCurrentZoomSelected(zoomValue)
            }
        }
        if (val === "out") {
            if (zoomLevel[getCurrentZoomIndex - 1]) {
                zoomValue = currentZoom = zoomLevel[getCurrentZoomIndex - 1]
                $chart.css('transform', cssDiv + " scale(" + zoomValue + "," + zoomValue + ")")
                console.log("zoomout " + zoomValue)
                setCurrentZoomSelected(zoomValue)
            }
        }
    }

    const divRefCallback = useCallback((node) => {
        if (node) {
            divRef.current = node
            setIsDomChartReady(true)
        }
    }, [])

    const createdNode = ($node, data) => {
        if (data?.children && data?.children?.length > 0) {
            $node.append(`<div class="toggle-icon" style="position: absolute;bottom: 11px;left: 171px;"><img src=${ArrowDown} width="15" height="15" alt="expand chart" node-id="${data?.id}" class="expand-collapse-btn" /></div>`)
        }
    }

    const toggleNode = (id) => {
        const node = $(`#${id}`)
        const childrenState = goalChartInstance.getNodeState(node, "children")
        const targetToggleNode = $('img[node-id="' + id + '"]')
        const childrenToggleNode = $('div[data-parent="' + id + '"] > .toggle-icon > img')
        if (childrenState?.visible) {
            targetToggleNode.attr("src", ArrowDown)
            goalChartInstance.hideChildren(node)
        } else {
            targetToggleNode.attr("src", ArrowUp)
            goalChartInstance.showChildren(node)
        }
        childrenToggleNode.attr("src", ArrowDown)
    }

    useEffect(() => {
        if (props.nodes && props.nodes.length > 0 && isDomChartReady) {
            let datas = props.nodes && props.nodes.length > 0 ? [...props.nodes] : []
            let structedData = []

            let parentNode = null
            parentNode = datas.find(item => item.pid === "")
            if (parentNode) {
                // recursive map children
                const callbackMap = (nodes, toAdd) => nodes.map((node, nodeIdx) => {
                    if (node?.id === toAdd?.pid) {
                        if (!node?.children) node = { ...node, children: [], 'collapsed': true }
                        node.children.push(toAdd)
                    } else {
                        if (node?.children) node.children = callbackMap(node.children, toAdd)
                    }
                    return node
                })
                structedData = [{ ...parentNode, 'collapsed': true }]
                datas = datas.filter(item => item.pid !== "")
                datas?.forEach(data => {
                    structedData = callbackMap(structedData, data)
                })
            }

            // custom ui
            var nodeTemplate = (data) => {
                let objData = data?.obj
                return `
                    <div style="border-radius: 7px; -webkit-box-shadow: 4px 4px 10px 0px rgba(0,0,0,0.1); -moz-box-shadow: 4px 4px 10px 0px rgba(0,0,0,0.1); box-shadow: 4px 4px 10px 0px rgba(0,0,0,0.1); font-family: Kanit; width: 350px;position: relative;">
                        <div class="goal-chart-head">
                            <div style="font-size: 16px; font-weight: 400; width: 90%;" class="tooltip"> 
                                <div style="color: white;font-size: 16px; font-weight: 600; text-overflow: ellipsis; overflow: hidden; width: 100%; -webkit-line-clamp: 2;display: -webkit-box; -webkit-box-orient: vertical; line-break: anywhere; text-align: left;">${objData?.name ?? ""}</div>
                                <div class="tooltiptext-bottom">${objData?.name}</div> 
                            </div>
                            <div style="font-size: 16px; font-weight: 400;" class="tooltip"> 
                                <a style="display: flex; align-items: center; width: 40px; height: 40px; justify-content: center;" class="btn-svg" href="/kpi/mygoal-detail/${objData?.serial}" target="_blank" rel="noopener noreferrer">
                                    <img src="${ViewDetailIcon}" width="20" height="20" alt="view detail"/>
                                </a>
                                <div class="tooltiptext-left">${'View Detail'}</div> 
                            </div>
                        </div>
                        <div class="goal-chart-detail">
                            <div style="height: 40px; display: flex;">
                                <div style="display: flex; width: 50px; margin-right: 5px;">
                                    <div class="goal-chart-profile-img">
                                        <img src="${objData?.employee?.photo && objData?.employee?.photo != "" ? objData.employee.photo : avatarIcon}" width="40" height="40"/>
                                    </div>
                                </div>
                                <div style="display: flex; flex-direction: column; margin-right: 5px; width: 100%;">
                                    <div style="height: 50%; display: flex; align-items: center; width: 100%;">
                                        <div style="font-size: 16px; font-weight: 400; width: 95%;" class="tooltip"> 
                                            <div style="text-overflow: ellipsis; white-space: nowrap; width: 100%; overflow: hidden; color: #404349; text-align: left;">${objData?.employee ? i18n.language === "th-TH" ? objData?.employee?.fullname_th : objData?.employee?.fullname_en : "Admin"} </div>
                                            <div class="tooltiptext">${objData?.employee ? i18n.language === "th-TH" ? objData?.employee?.fullname_th : objData?.employee?.fullname_en : "Admin"}</div> 
                                        </div>
                                    </div>
                                    <div style="height: 50%; display: flex; align-items: center; width: 100%;">
                                        <div style="font-size: 13px; font-weight: 400; color: #888F9D; width: 95%;" class="tooltip"> 
                                            <div style="text-overflow: ellipsis; white-space: nowrap; width: 100%; overflow: hidden; text-align: left;">${objData?.employee ? objData?.employee?.position : ""} ${objData?.employee ? "(" + objData?.employee?.organization + ")" : ""} </div>
                                            <div class="tooltiptext">${objData?.employee ? objData?.employee?.position : ""} ${objData?.employee ? "(" + objData?.employee?.organization + ")" : ""} </div> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="width: 100%; height: 1px; background-color: #E7E8E7; margin-top: 10px; margin-bottom: 10px;"></div>
                            <div style="display: flex; margin-bottom: 10px;">
                                <div style="display: flex;">
                                    <div style="height: 50%; display: flex; align-items: center;">
                                        <p style="font-size: 16px; font-weight: 400; color: #AAAAAA;"> Progress: </p>
                                    </div>
                                </div>
                                <div style="display: flex; flex-direction: column; margin-left: auto;">
                                    <div style="width: 120px; padding-top: 8px; padding-bottom: 8px; height: 40px; text-align: center; border-radius: 5px; display: flex; align-items: center; justify-content: center; border: ${objData?.goal_progress?.goal_progress_data?.name === "Not Started" || objData?.goal_progress?.goal_progress_data?.name === "ยังไม่ได้ดำเนินการ" ? "1px solid #DADADA" : "0"}; background-color: ${objData?.goal_progress?.goal_progress_data?.color?.background ?? "#FFF"}; color: ${objData?.goal_progress?.goal_progress_data?.color?.font ?? "#DADADA"};">
                                        <p style="cursor: default; font-size: 13px;">${objData?.goal_progress?.goal_progress_data?.name}</p>
                                    </div>
                                </div>
                            </div>
                            <div style="display: flex; margin-bottom: 0px;">
                                    <div style="display: flex; align-items: center;">
                                        <p style="font-size: 16px; font-weight: 400; color: #AAAAAA;"> Actual Value: </p>
                                    </div>
                                <div style="display: flex; flex-direction: column; margin-left: auto;">
                                    <p style="font-size: 16px; font-weight: 400; color:${objData?.progress_log?.length > 0 ? validateActualValueColor(objData?.progress_log?.[0]?.actual_value, objData?.goal_progress?.target_value, objData?.goal_progress?.goal_metric?.description, objData?.target_condition) ? "#5DA196" : "#CC6058" : "#828282"};"> ${objData?.progress_log?.[0]?.actual_value ?? ""} ${objData?.progress_log?.length > 0 && objData?.progress_log?.[0]?.actual_value !== "" ? objData?.goal_progress?.unit != "-" ? objData?.goal_progress?.unit : "" : "-"}</p>
                                </div>
                            </div>
                            <div style="display: flex; margin-bottom: 10px;">
                                <div style="display: flex; flex-direction: column; margin-left: auto;">
                                    <p style="font-size: 14px; font-weight: 400; color: #AAAAAA;"> (Result as of: ${objData?.progress_log?.[0]?.date ? Util.dateDayFormatAdmin(objData?.progress_log?.[0]?.date) : "-"}) </p>
                                </div>
                            </div>
                            <div style="display: flex; margin-bottom: 10px;">
                                <div style="display: flex; align-items: center;">
                                    <p style="font-size: 16px; font-weight: 400; color: #AAAAAA;"> Target Value: </p>
                                </div>
                                <div style="display: flex; flex-direction: column; margin-left: auto;">
                                    <p style="font-size: 16px; font-weight: 400; color: #404349;"> ${objData?.target_condition && objData?.target_condition != "" ? Util.capitalizedString(objData.target_condition) : ""} ${objData?.goal_progress?.target_value} ${objData?.goal_progress?.unit === "-" ? "" : objData?.goal_progress?.unit + "(s)"} </p>
                                </div>
                            </div>
                            <div style="display: flex; margin-bottom: 10px;">
                                <div style="display: flex; align-items: center;">
                                    <p style="font-size: 16px; font-weight: 400; color: #AAAAAA;"> Start Date-End Date: </p>
                                </div>
                                <div style="display: flex; flex-direction: column; margin-left: auto;">
                                    <p style="font-size: 16px; font-weight: 400; color: #404349;"> ${objData?.goal_progress?.start_date}-${objData?.goal_progress?.end_date} </p>
                                </div>
                            </div>
                            <div style="margin-bottom: 20px;"></div>
                        </div>
                    </div>`
            }

            goalChartInstance = $('#goal-chart').orgchart({
                'data': structedData?.[0],
                'nodeTemplate': nodeTemplate,
                'pan': true,
                'initCompleted': () => {
                    setTimeout(() => {
                        if (!$chart) {
                            zoomInstance()
                        }
                    }, 500)
                    console.log("goal chart inited")

                    $(".expand-collapse-btn").on("click", (node) => {
                        toggleNode(node.currentTarget.attributes["node-id"].value)
                    })
                },
                'createNode': ($node, data) => {
                    createdNode($node, data)
                },
            })

            goalChartInstance.$chartContainer.on('touchmove', function (event) {
                event.preventDefault()
            })
        }
    }, [props.nodes, isDomChartReady])

    return (
        <React.Fragment>
            <div id="goal-chart-container" class="boc-light" style={{ height: 'calc(100vh - 250px)', width: '100%', textAlign: "center", overflow: "scroll" }}>
                <div id="goal-chart" ref={divRefCallback} />
            </div>
            <div style={{
                position: 'absolute',
                right: '40px',
                top: '80px',
                display: 'flex',
            }}>
                <div id="chartzoomout" style={{ borderRadius: '4px 0px 0px 4px' }} class="zoomBtn" onClick={() => doZoom("out")}><MinusIcon></MinusIcon></div>
                <Select
                    id="metric-select"
                    variant="outlined"
                    defaultValue=""
                    displayEmpty
                    size="small"
                    fullWidth
                    className="white-bg"
                    sx={{ width: '100px', borderRadius: "0!important", borderLeft: 0, borderRight: 0 }}
                    value={currentZoomSelected}
                >
                    <MenuItem value={0.25} onClick={() => setZoomLevel(0.25)}>
                        <Typography variant="sub_label" style={{ fontWeight: "400" }}>25%</Typography>
                    </MenuItem>
                    <MenuItem value={0.5} onClick={() => setZoomLevel(0.5)}>
                        <Typography variant="sub_label" style={{ fontWeight: "400" }}>50%</Typography>
                    </MenuItem>
                    <MenuItem value={0.75} onClick={() => setZoomLevel(0.75)}>
                        <Typography variant="sub_label" style={{ fontWeight: "400" }}>75%</Typography>
                    </MenuItem>
                    <MenuItem value={1} onClick={() => setZoomLevel(1)}>
                        <Typography variant="sub_label" style={{ fontWeight: "400" }}>100%</Typography>
                    </MenuItem>
                    <MenuItem value={1.5} onClick={() => setZoomLevel(1.5)}>
                        <Typography variant="sub_label" style={{ fontWeight: "400" }}>150%</Typography>
                    </MenuItem>
                    <MenuItem value={2} onClick={() => setZoomLevel(2)}>
                        <Typography variant="sub_label" style={{ fontWeight: "400" }}>200%</Typography>
                    </MenuItem>
                    <MenuItem value={3} onClick={() => setZoomLevel(3)}>
                        <Typography variant="sub_label" style={{ fontWeight: "400" }}>300%</Typography>
                    </MenuItem>
                </Select>
                <div id="chartzoomin" style={{ borderRadius: '0px 4px 4px 0px' }} class="zoomBtn" onClick={() => doZoom("in")}><PlusIcon></PlusIcon></div>
            </div>
        </React.Fragment>
    )
}

export default GoalChart;
